
// components/ReportHeader.js
import React from 'react';
import useOrgDetails from '../utils/useOrgDetails';
import Image from 'react-bootstrap/Image';
import orgmsLogo from '../images/ggsf_logo.jpeg';

const ReportHeader = (props) => {
    const { orgDetails, isLoading, error } = useOrgDetails(props);

    if (isLoading) return <p>Loading...</p>;
    if (error) return <p>{error}</p>;

    return (
        <div className="summary-section">
            <div className="summary-left">
                <p className="bold-text small-font">{orgDetails.name}</p>
                <p className="small-font">{orgDetails.address} {orgDetails.address2}</p>
                <p className="small-font">{orgDetails.city}, {orgDetails.state} {orgDetails.zip}</p>
                <p className="small-font">Phone: {orgDetails.phone}</p>
            </div>
            <div className="summary-center">
                <div className="image-container">
                    <Image
                        src={orgmsLogo}
                        alt="ORGMS Logo"
                        fluid
                        style={{
                            width: '200px',
                            height: 'auto'
                        }}
                    />
                </div>
            </div>
            <div className="summary-right">
                {/* Pass the summary-right values here */}
                {props.summaryRight && props.summaryRight.map((item, index) => (
                    <p key={index} className="bold-text small-font">{item}</p>
                ))}
            </div>
        </div>
    );
};

export default ReportHeader;